import { useItemsFine } from "../_actions/app/items";
import log from "cslog";
import { useState } from "react";
import {
    Card,
    Row,
    Col,
    Button,
    Space,
    Spin,
    Empty,
    Typography,
    Avatar,
    Flex,
    Layout,
} from "antd";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { TeamOutlined } from "@ant-design/icons";
import { getPublicImageURL } from "../_helpers/image";
import { VscOrganization } from "react-icons/vsc";
import {
    EditOutlined,
    DollarOutlined,
    ApartmentOutlined,
} from "@ant-design/icons";
import Paragraph from "antd/es/typography/Paragraph";
import BrandEditPage from "../../src/qbuilt_settings/brands/org/BrandEditPage";

const { Text, Title } = Typography;
const { Content } = Layout;

function AllOrganizations() {
    const {
        data: organizations,
        isLoading,
        refetch,
    } = useItemsFine(
        "qdb_organization",
        "limit=100&fields=id,name,logo,industry.name,owner.first_name,owner.last_name,owner.id,is_personal,is_external,users.id,token_plan.count"
    );

    const [editParams, setEditParams] = useState(null);

    log.d(organizations, "All Organizations Data");

    if (editParams) {
        return (
            <BrandEditPage
                params={editParams}
                isAdmin={editParams.isAdmin}
                onCancel={() => setEditParams(null)}
            />
        );
    }

    if (isLoading) {
        return (
            <QurealSection
                header={
                    <SectionHeader
                        heading="All Organizations"
                        icon={<TeamOutlined />}
                    />
                }
            >
                <Card styles={{ body: { padding: 40 } }}>
                    <Flex vertical align="center" gap="middle">
                        <Spin size="large" />
                        <Text strong>Loading organizations...</Text>
                    </Flex>
                </Card>
            </QurealSection>
        );
    }

    const organizationList = Array.isArray(organizations)
        ? organizations
        : organizations?.data || [];

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="All Organizations"
                    icon={<TeamOutlined />}
                />
            }
        >
            <Content style={{ padding: "32px", background: "#f8fafc" }}>
                {organizationList.length === 0 ? (
                    <Card styles={{ body: { padding: 60 } }}>
                        <Empty
                            description={
                                <Space direction="vertical" size="small">
                                    <Title level={3} type="secondary">
                                        No organizations found
                                    </Title>
                                    <Text type="secondary">
                                        Start by creating your first
                                        organization
                                    </Text>
                                </Space>
                            }
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                    </Card>
                ) : (
                    <Row gutter={[24, 24]} justify="start">
                        {organizationList.map((org) => (
                            <Col xs={24} sm={12} lg={8} xl={6} key={org.id}>
                                <Card
                                    hoverable
                                    styles={{ body: { padding: "0" } }}
                                >
                                    {/* Header Section */}
                                    <div
                                        style={{
                                            background: "#f8fafc",
                                            padding: "14px 16px 0",
                                        }}
                                    >
                                        <Flex
                                            vertical
                                            align="flex-start"
                                            gap={12}
                                        >
                                            <Flex
                                                align="center"
                                                style={{
                                                    height: 70,
                                                }}
                                            >
                                                {org.logo ? (
                                                    <img
                                                        src={getPublicImageURL(
                                                            org.logo
                                                        )}
                                                        alt={org.name}
                                                        style={{
                                                            width: "auto",
                                                            maxWidth: "100%",
                                                            height: "100%",
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                    />
                                                ) : (
                                                    <VscOrganization
                                                        size={74}
                                                        color="#595959"
                                                    />
                                                )}
                                            </Flex>
                                            <Space
                                                direction="vertical"
                                                // size={6}
                                                style={{
                                                    width: "100%",
                                                    background: "white",
                                                }}
                                            >
                                                <Title
                                                    level={5}
                                                    style={{
                                                        marginBottom: 0,
                                                        marginTop: 12,
                                                    }}
                                                >
                                                    {org.name}
                                                </Title>
                                                <Paragraph copyable>
                                                    {org.id}
                                                </Paragraph>
                                            </Space>
                                        </Flex>
                                    </div>

                                    {/* Content Section */}
                                    <div style={{ padding: "12px 16px" }}>
                                        <Space
                                            direction="vertical"
                                            // size="small"
                                            style={{ width: "100%" }}
                                        >
                                            {/* Members */}
                                            <Flex align="center" gap={18}>
                                                <Avatar
                                                    size={28}
                                                    style={{
                                                        background: "#e6f7ff",
                                                        color: "#1890ff",
                                                    }}
                                                    icon={<TeamOutlined />}
                                                />
                                                <Text>
                                                    Members:{" "}
                                                    {org.users?.length || 0}
                                                </Text>
                                            </Flex>
                                            {/* Tokens */}
                                            <Flex align="center" gap={18}>
                                                <Avatar
                                                    size={28}
                                                    style={{
                                                        background: "#f6ffed",
                                                        color: "#52c41a",
                                                    }}
                                                    icon={<DollarOutlined />}
                                                />
                                                <Text>
                                                    Tokens:{" "}
                                                    {org.token_plan?.count || 0}
                                                </Text>
                                            </Flex>
                                            {/* Industry */}
                                            <Flex align="center" gap={18}>
                                                <Avatar
                                                    size={28}
                                                    style={{
                                                        background: "#fff7e6",
                                                        color: "#fa8c16",
                                                    }}
                                                    icon={<ApartmentOutlined />}
                                                />
                                                <Text
                                                    ellipsis={{
                                                        rows: 1,
                                                        tooltip:
                                                            org.industry
                                                                ?.name || "N/A",
                                                    }}
                                                >
                                                    Industry:{" "}
                                                    {org.industry?.name ||
                                                        "N/A"}
                                                </Text>
                                            </Flex>

                                            {/* Owner */}
                                            <Card size="small">
                                                <Flex align="center" gap={8}>
                                                    <Text type="secondary">
                                                        Owner:
                                                    </Text>
                                                    <Text type="secondary">
                                                        {org.owner
                                                            ?.first_name &&
                                                        org.owner?.last_name
                                                            ? `${org.owner.first_name} ${org.owner.last_name}`
                                                            : "N/A"}
                                                    </Text>
                                                </Flex>
                                            </Card>

                                            {/* Edit Button */}
                                            <Button
                                                // color="primary"
                                                variant="solid"
                                                icon={<EditOutlined />}
                                                size="default"
                                                block
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log(
                                                        "Opening BrandEditPage for org:",
                                                        org.id
                                                    );
                                                    setEditParams({
                                                        id: org.id,
                                                        isAdmin: true,
                                                    });
                                                }}
                                            >
                                                Edit
                                            </Button>
                                        </Space>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Content>
        </QurealSection>
    );
}

export default AllOrganizations;
